<template>
    <div>
        <compWrapper title="添加角色" theme="primary" >
            <compFormQuery v-if="type=='query'" class="margin-15 clearfix" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
            <compFormEdit v-else class="margin-15 clearfix" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="120"  />
            <div v-if="type !== 'query'" class="text-right padding-bottom-20 padding-right-20">
                <Button type="primary" @click="submit">保存</Button>
                <Button class="margin-left-10" @click="cancel">取消</Button>
            </div>
        </compWrapper>
        <compWrapper :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="gray" v-if="type==='query'">
            <compLog class="margin-layout" :data="logList" :columns="logcolumn"></compLog>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>
<script>
import { HttpGetRoleDetail, HttpAddRole, HttpGetLog } from "@/service/department/rolemanage.js"
export default {
    props: ["activeids", "querytype"],
    data() {
      return {
        type: this.$route.params.type || this.querytype,
        id: this.$route.query.id || this.activeids,
        formData: {},
        loading: false,
        logList:[],
      };
    },
    created() {
        if (this.type !== "add") {
            this.getDetail();
        }
        if(this.type == 'query'){
            this.getLog()
        }
    },
    computed: {
        getBase() {
            return [
                {
                    label: "角色名称",
                    key: "name",
                    tag: "Input",
                },
                {
                    label: "备注",
                    key: "description",
                    tag: "Input",
                    required: false,
                },
            ];
        },
        logcolumn(){
            return [
                {
                    title:this.$t('global.common.operator',{defaultValue:'操作人'}),
                    key:'createdName',
                },
                {
                    title:this.$t('global.common.operate_time',{defaultValue:'操作时间'}),
                    key:'createdAt',
                },
                {
                    title:this.$t('global.common.operate_type',{defaultValue:'操作类型'}),
                    key: 'opAction'
                },
                {
                    title:this.$t('global.common.notes',{defaultValue:'备注'}),
                    key:'opRemark',
                },

            ]
        }
    },
    methods: {
        getDetail() {
            this.loading = true;
            HttpGetRoleDetail({
                id: this.id,
            }).then(
                (res) => {
                    this.formData = res.data;
                    this.loading = false;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                    this.loading = false;
                }
            );
        },
        getLog(){
            HttpGetLog({
                dataId: this.id,
                model: 'UcApprovalRole'
            }).then(
                (res) => {
                    this.logList = res.data.content;
                    this.loading = false;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                    this.loading = false;
                }
            );
        },
        async submit() {
            if(!this.formData.name){ this.$Message.error({content: '请填写角色名称', duration: 10, closable: true}); return;}
            this.loading = true;
            HttpAddRole({
                ...this.formData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.cancel();
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        cancel() {
            this.$router.push({
                name: "roleManage",
            });
        },
    },
};
</script>
